<template>
    <div>
        <el-container>
            <el-aside width="200px">
                <div style="text-align:center; line-height:60px;">
                    vue-admin
                </div>
                <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
                    background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-location"></i>
                            <span>导航一</span>
                        </template>
                        <el-menu-item-group>
                            <template slot="title">分组一</template>
                            <el-menu-item index="1-1">选项1</el-menu-item>
                            <el-menu-item index="1-2">选项2</el-menu-item>
                        </el-menu-item-group>
                        <el-menu-item-group title="分组2">
                            <el-menu-item index="1-3">选项3</el-menu-item>
                        </el-menu-item-group>
                        <el-submenu index="1-4">
                            <template slot="title">选项4</template>
                            <el-menu-item index="1-4-1">选项1</el-menu-item>
                        </el-submenu>
                    </el-submenu>
                    <el-menu-item index="2">
                        <i class="el-icon-menu"></i>
                        <span slot="title">导航二</span>
                    </el-menu-item>
                    <el-menu-item index="3" disabled>
                        <i class="el-icon-document"></i>
                        <span slot="title">导航三</span>
                    </el-menu-item>
                    <el-menu-item index="4">
                        <i class="el-icon-setting"></i>
                        <span slot="title">导航四</span>
                    </el-menu-item>
                </el-menu>

            </el-aside>
            <el-container>
                <el-main>
                    <div style="position: relative; height:100%; overflow: hidden;">
                        <el-header>Header</el-header>
                        <div style="height:100%; overflow-y: auto; padding-top:65px; box-sizing: border-box;">
                            <div style="">
                                <div v-for="i in 500" :key="i">{{ i }}</div>
                            </div>

                            <div style="width:100%; height:20px;"></div>
                        </div>

                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
export default {
    name: 'admin'
}
</script>

<style scoped lang="stylus">
.el-menu{
border-right: 0;
}

.el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  .el-header{
    position: absolute;
    background-color: #fff;
    top: 0;
    width: 100%;
    right: 0;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    height: 100vh;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    height: 100vh;
    padding: 0;
  }
  ::-webkit-scrollbar {
    width: 7px;
    height: 8px;
}
::-webkit-scrollbar-thumb {
    background-color: #9093994d;
    border-radius: 10px;
    box-shadow: inset 0 0 6px #0003;
}

::-webkit-scrollbar-thumb:hover{
    background: #ACADAF;
}

::-webkit-scrollbar-track {
    background-color: #0000000d;
}

</style>


// WEBPACK FOOTER //
// src/pages/admin/admin.vue